export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48')
];

export const server_loads = [];

export const dictionary = {
		"/": [16],
		"/invitation/[token]": [41,[13,14]],
		"/(app)/requests/[request_id]": [18,[2],[3]],
		"/(app)/schema-form-demo": [19,[2],[3]],
		"/settings": [42,[15]],
		"/settings/api-keys": [43,[15]],
		"/settings/document-templates": [44,[15]],
		"/settings/members": [45,[15]],
		"/settings/profile": [46,[15]],
		"/settings/workbook-templates": [47,[15]],
		"/settings/workspace": [48,[15]],
		"/(app)/support": [20,[2],[3]],
		"/(app)/workbooks": [21,[2],[3]],
		"/(app)/workbooks/new": [33,[2],[3]],
		"/(app)/workbooks/[workbook_id]/diff-worksheets": [23,[2,4],[3]],
		"/(app)/workbooks/[workbook_id]/documents": [24,[2,4],[3]],
		"/(app)/workbooks/[workbook_id]/findings": [25,[2,4,6],[3]],
		"/(app)/workbooks/[workbook_id]/findings/[finding_id]": [26,[2,4,6],[3]],
		"/(app)/workbooks/[workbook_id]/generate-population": [27,[2,4],[3]],
		"/(app)/workbooks/[workbook_id]/population/[worksheet_id]": [28,[2,4,7],[3]],
		"/(app)/workbooks/[workbook_id]/report": [29,[2,4,8],[3]],
		"/(app)/workbooks/[workbook_id]/requirements": [30,[2,4],[3]],
		"/(app)/workbooks/[workbook_id]/setup": [31,[2,4,9],[3]],
		"/(app)/workbooks/[workbook_id]/standalone/[worksheet_id]": [32,[2,4,10],[3]],
		"/(app)/workbooks/[workbook_id]/[worksheet_id]": [22,[2,4,5],[3]],
		"/(app)/workflows/library": [34,[2,11],[3]],
		"/(app)/workflows/library/catalogue": [35,[2,11],[3]],
		"/(app)/workflows/library/recent": [36,[2,11],[3]],
		"/(app)/workflows/perform/[workbook_id]/control-gap-analysis": [37,[2,12],[3]],
		"/(app)/workflows/perform/[workbook_id]/extract-941-employer-tax-data": [38,[2,12],[3]],
		"/(app)/workflows/perform/[workbook_id]/pick-a-sample": [39,[2,12],[3]],
		"/(app)/workflows/perform/[workbook_id]/policy-to-control": [40,[2,12],[3]],
		"/(app)/[...path]": [17,[2],[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';